import React from 'react';
import { ExperimentContext } from './Context';

export function useExperiments() {
  const context = React.useContext(ExperimentContext);
  if (context === undefined) {
    throw new Error('Context must be used within a provider');
  }
  return context;
}
